import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "24",
  height: "24",
  rx: "12",
  fill: "#4D9231"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M18.087 7.792C18.078 7.78069 18.0682 7.76988 18.0577 7.75966C17.5888 7.30279 16.8367 7.30277 16.3677 7.75961L10.2647 13.7033L7.63513 11.1438C7.16618 10.687 6.41396 10.6869 5.94506 11.1438C5.46281 11.6136 5.46281 12.387 5.94506 12.8569L9.41835 16.241C9.8873 16.6979 10.6395 16.6979 11.1084 16.241L18.055 9.47281C18.5264 9.01358 18.537 8.26435 18.087 7.792Z",
  fill: "white"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }